import {createRouter, createWebHistory} from 'vue-router'
import store from "../store";

const Tenant = () => import('../components/pages/TenantPage.vue')
const NewsIndex = () => import('../components/pages/News/Index.vue')
const NewsCreate = () => import('../components/pages/News/Create.vue')
const NewsEdit = () => import('../components/pages/News/Edit.vue')
const PromotionIndex = () => import('../components/pages/Promotion/Index.vue')
const PromotionCreate = () => import('../components/pages/Promotion/Create.vue')
const PromotionEdit = () => import('../components/pages/Promotion/Edit.vue')
const MallPageManagement = () => import('../components/pages/Page/Index.vue')
const MallPageAvenuel = () => import('../components/pages/Page/Avenuel.vue')
const Fashion = () => import('../components/pages/Page/Fashion.vue')
const HeaderFooterManagement = () => import('../components/pages/Page/HeaderFooter.vue')
const Login = () => import('../components/LoginPage.vue')
const NotFound = () => import('../components/NotFoundPage.vue')
const MasterData = () => import('../components/pages/MasterData/MasterDataPage.vue')
const CategoryIndex = () => import('../components/pages/MasterData/CategoryIndex.vue')
const AvenuelColorIndex = () => import('../components/pages/MasterData/AveneulColorIndex.vue')
const ServiceIndex = () => import('../components/pages/MasterData/ServiceIndex.vue')
const FaB = () => import('../components/pages/Page/FaB.vue')
const Entertainment = () => import('../components/pages/Page/Entertainment.vue')
const MainPromotion = () => import('../components/pages/Page/Promotion.vue')
const MainNew = () => import('../components/pages/Page/New.vue')
const MainService = () => import('../components/pages/Page/Service.vue')
const Visit = () => import('../components/pages/Page/Visit.vue')
const HotelIndex = () => import('../components/pages/Hotel/Index.vue')
const FamilyIndex =() => import('../components/pages/Family/Index.vue')
const Aquarium =() => import('../components/pages/Family/Aquarium.vue')
const Bunker =() => import('../components/pages/Family/Bunker.vue')
const Cinema =() => import('../components/pages/Family/Cinema.vue')
const Collection =() => import('../components/pages/Family/Collection.vue')
const News =() => import('../components/pages/Family/News.vue')
const HotelCollection = () => import('../components/pages/Hotel/Collection.vue')
const HotelPromotion = () => import('../components/pages/Hotel/Promotion.vue')
const HotelResidence = () => import('../components/pages/Hotel/Residence.vue')
const HotelDining = () => import('../components/pages/Hotel/Dining.vue')
const HotelService = () => import('../components/pages/Hotel/Service.vue')
const HotelMeeting = () => import('../components/pages/Hotel/Meeting.vue')
const OfficeIndex = () => import('../components/pages/Office/Index.vue')
const OfficeSpecification = () => import('../components/pages/Office/Specification.vue')
const OfficeAmenity = () => import('../components/pages/Office/Amenity.vue')

const routes = [
    {
        path: "/admin/login",
        name: 'admin.login',
        component: Login,
        meta: {
            middleware: "guest",
            title: `Login`,
            meta: {
                middleware: "guest",
            }
        }
    },
    {
        path: "/admin/tenants",
        name: 'admin.tenants',
        component: Tenant,
        meta: {
            middleware: "auth",
            title: `Tenant Management`
        },
    },
    {
        path: "/admin/news",
        name: 'admin.news',
        component: NewsIndex,
        meta: {
            middleware: "auth",
            title: `News and events`
        },
    },
    {
        path: "/admin/news/create",
        name: 'admin.news.create',
        component: NewsCreate,
        meta: {
            middleware: "auth",
            title: `News and events`
        }
    },
    {
        path: "/admin/news/:id",
        name: 'admin.news.edit',
        component: NewsEdit,
        meta: {
            middleware: "auth",
            title: `News and events`
        }
    },
    {
        path: "/admin/promotions",
        name: 'admin.promotion',
        component: PromotionIndex,
        meta: {
            middleware: "auth",
            title: `Promotion`
        },
    },
    {
        path: "/admin/promotions/create",
        name: 'admin.promotion.create',
        component: PromotionCreate,
        meta: {
            middleware: "auth",
            title: `Promotion`
        }
    },
    {
        path: "/admin/promotions/:id",
        name: 'admin.promotion.edit',
        component: PromotionEdit,
        meta: {
            middleware: "auth",
            title: `Promotion`
        }
    },
    {
        path: "/admin/master-data",
        name: 'admin.master-data',
        component: MasterData,
        meta: {
            middleware: "auth",
            title: `Section`
        },
    },
    {
        path: "/admin/master-data/categories",
        name: 'admin.categories',
        component: CategoryIndex,
        meta: {
            middleware: "auth",
            title: `Category`
        },
    },
    {
        path: "/admin/master-data/aveneul-color",
        name: 'admin.aveneul-color',
        component: AvenuelColorIndex,
        meta: {
            middleware: "auth",
            title: `MEMBERSHIP`
        },
    },
    {
        path: "/admin/master-data/service",
        name: 'admin.service',
        component: ServiceIndex,
        meta: {
          middleware: "auth",
          title: `Service`
        },
    },
    {
        path: "/admin/pages",
        name: 'admin.pages',
        component: MallPageManagement,
        meta: {
            middleware: "auth",
            title: `Page Management`
        }
    },
    {
        path: "/admin/avenuel",
        name: 'admin.avenuel',
        component: MallPageAvenuel,
        meta: {
            middleware: "auth",
            title: `Mall Page Avenuel`
        }
    },
    {
        path: "/admin/fashion",
        name: 'admin.fashion',
        component: Fashion,
        meta: {
            middleware: "auth",
            title: `FASHION`
        }
    },
    {
        path: "/admin/fab",
        name: 'admin.fab',
        component: FaB,
        meta: {
            middleware: "auth",
            title: `F&B`
        }
    },
    {
        path: "/admin/entertainment",
        name: 'admin.entertainment',
        component: Entertainment,
        meta: {
            middleware: "auth",
            title: `ENTERTAINMENT`
        }
    },
    {
        path: "/admin/main-promotion",
        name: 'admin.main-promotion',
        component: MainPromotion,
        meta: {
            middleware: "auth",
            title: `PROMOTION`
        }
    },
    {
        path: "/admin/main-new",
        name: 'admin.main-new',
        component: MainNew,
        meta: {
            middleware: "auth",
            title: `NEW`
        }
    },
    {
        path: "/admin/main-service",
        name: 'admin.main-service',
        component: MainService,
        meta: {
          middleware: "auth",
          title: `SERVICE`
        }
    },
      {
        path: "/admin/visit",
        name: 'admin.visit',
        component: Visit,
        meta: {
          middleware: "auth",
          title: `Page Management`
        }
      },

  {
        path: "/admin/hotel",
        name: 'admin.hotel',
        component: HotelIndex,
        meta: {
            middleware: "auth",
            title: `Mall Homepage Management`
        }
    },
    {
        path: "/admin/hotel/collection",
        name: 'admin.hotel.collection',
        component: HotelCollection,
        meta: {
            middleware: "auth",
            title: `Mall Homepage Management`
        }
    },
    {
        path: "/admin/hotel/promotion",
        name: 'admin.hotel.promotion',
        component: HotelPromotion,
        meta: {
            middleware: "auth",
            title: `Mall Homepage Management`
        }
    },
    {
        path: "/admin/hotel/residence",
        name: 'admin.hotel.residence',
        component: HotelResidence,
        meta: {
            middleware: "auth",
            title: `Mall Homepage Management`
        }
    },
    {
        path: "/admin/hotel/dining",
        name: 'admin.hotel.dining',
        component: HotelDining,
        meta: {
            middleware: "auth",
            title: `Mall Homepage Management`
        }
    },
    {
        path: "/admin/hotel/service",
        name: 'admin.hotel.service',
        component: HotelService,
        meta: {
            middleware: "auth",
            title: `Mall Homepage Management`
        }
    },
    {
        path: "/admin/hotel/meeting",
        name: 'admin.hotel.meeting',
        component: HotelMeeting,
        meta: {
            middleware: "auth",
            title: `Mall Homepage Management`
        }
    },
    {
        path: "/admin/office",
        name: 'admin.office.index',
        component: OfficeIndex,
        meta: {
            middleware: "auth",
            title: `Lotte Office Sub-page Management`
        }
    },
    {
        path: "/admin/office/specification",
        name: 'admin.office.specification',
        component: OfficeSpecification,
        meta: {
            middleware: "auth",
            title: `Lotte Office Sub-page Management`
        }
    },
    {
        path: "/admin/office/amenity",
        name: 'admin.office.amenity',
        component: OfficeAmenity,
        meta: {
            middleware: "auth",
            title: `Lotte Office Sub-page Management`
        }
    },
    {
        path: "/admin/pages/header-footer",
        name: 'admin.pages.header-footer',
        component: HeaderFooterManagement,
        meta: {
            middleware: "auth",
            title: `Header Footer Management`
        }
    },
      {
        path: "/admin/family",
        name: 'admin.family',
        component: FamilyIndex,
        meta: {
          middleware: "auth",
          title: `Lotte Family Management`
        }
      },
      {
        path: "/admin/family/aquarium",
        name: 'admin.family.aquarium',
        component: Aquarium,
        meta: {
          middleware: "auth",
          title: `AQUARIUM`
        }
      },
      {
        path: "/admin/family/bunker",
        name: 'admin.family.bunker',
        component: Bunker,
        meta: {
          middleware: "auth",
          title: `BOTTLE BUNKER`
        }
      },
      {
        path: "/admin/family/cinema",
        name: 'admin.family.cinema',
        component: Cinema,
        meta: {
          middleware: "auth",
          title: `LOTTE CINEMA`
        }
      },
      {
        path: "/admin/family/collection",
        name: 'admin.family.collection',
        component: Collection,
        meta: {
          middleware: "auth",
          title: `PHOTO COLLECTION`
        }
      },
      {
        path: "/admin/family/news",
        name: 'admin.family.news',
        component: News,
        meta: {
          middleware: "auth",
          title: `NEWS AND EVENTS`
        }
      },

    {
        path: '/:pathMatch(.*)',
        name: 'NotFound',
        component: NotFound
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response.status === 401) {
            store.dispatch('auth/logout')
            window.location.href = '/admin/login'
        }
    });

router.beforeEach((to, from, next) => {
    if (to.meta.middleware == "guest") {
        if (store.state.auth.authenticated) {
            next({name: "admin.tenants"})
        }
        next()
    } else {
        if (store.state.auth.authenticated) {
            next()
        } else {
            next({name: "admin.login"})
        }
    }
})

export default router
